"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n        position: relative;\n        width: ", ";\n        height: ", ";\n        ", " ", ";\n    "], ["\n        position: relative;\n        width: ", ";\n        height: ", ";\n        ", " ", ";\n    "]),
    _templateObject2 = _taggedTemplateLiteral(["\n                margin: auto;\n            "], ["\n                margin: auto;\n            "]),
    _templateObject3 = _taggedTemplateLiteral(["\n                    float: right;\n                "], ["\n                    float: right;\n                "]),
    _templateObject4 = _taggedTemplateLiteral(["\n        margin: auto;\n        width: 50%;\n        height: 50%;\n    "], ["\n        margin: auto;\n        width: 50%;\n        height: 50%;\n    "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLoading = require("react-loading");

var _reactLoading2 = _interopRequireDefault(_reactLoading);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Loading = function Loading(props) {
    var LoadingOuter = _styledComponents2.default.div(_templateObject, props.width, props.height, props.align == "center" && (0, _styledComponents.css)(_templateObject2), props.align == "right" && (0, _styledComponents.css)(_templateObject3));

    var LoadingInner = _styledComponents2.default.div(_templateObject4);
    return _react2.default.createElement(
        LoadingOuter,
        null,
        _react2.default.createElement(
            LoadingInner,
            null,
            _react2.default.createElement(_reactLoading2.default, {
                type: props.type,
                color: props.color,
                width: "100%",
                height: "100%"
            })
        )
    );
};
Loading.displayName = "Loading";

Loading.propTypes = {
    /** A css color (using rgba will allow transparency) */
    color: _propTypes2.default.string,
    /** One of the types provided by react-loading, e.g. currently ["blank",
        "balls",
        "bars",
        "bubbles",
        "cubes",
        "cylon",
        "spin",
        "spinningBubbles",
        "spokes"] */
    type: _propTypes2.default.oneOf(["blank", "balls", "bars", "bubbles", "cubes", "cylon", "spin", "spinningBubbles", "spokes"]),
    /** A css width */
    width: _propTypes2.default.string,
    /** A css height */
    height: _propTypes2.default.string,
    /** left, right or center */
    align: _propTypes2.default.string
};

Loading.defaultProps = {
    color: "rgba(0,0,0,0.3)",
    type: "spin",
    width: "200px",
    height: "200px",
    align: "left"
};
exports.default = Loading;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/Loading.js
// module id = 987
// module chunks = 95715928098905 168707334958949